import { forwardRef, type Ref, type SVGProps } from "react";
const IconTagOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M22.001 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
    <path
      fillRule="evenodd"
      d="M18.001 2h10a2.006 2.006 0 0 1 2 2v10a1.97 1.97 0 0 1-.59 1.41l-14 14a1.98 1.98 0 0 1-2.82 0l-10-10a1.974 1.974 0 0 1 0-2.82l14-14c.371-.379.88-.592 1.41-.59m-4 26 14-14V4h-10l-14 14z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTagOutlineSVG);
ForwardRef.displayName = "IconTagOutline";
export { ForwardRef as IconTagOutline };
